export default import.meta.ROLLDOWN_FILE_URL_y4Enn1ppqbFiD7shn9d2Iw